import universal from 'react-universal-component';

export default universal(() => import('./MatchupAnalysis'));



// WEBPACK FOOTER //
// ./src/app/views/Predictions/MatchupAnalysis/index.js